const apiUrl = process.env.REACT_APP_API_URL;
export const GetGrups = async (id : number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id}/grups`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
